import React from "react";
import { HelperText } from "react-native-paper";
import { useTranslation } from "react-i18next";
import { FormDatePicker } from "../FormDatePicker";
import { Timestamp } from "firebase/firestore";
import {Field} from "../../config/companies/config";

interface DateFieldProps {
  field: Field;
  value: any;
  onChange: (fieldName: string, newValue: any) => void;
  errors?: { [key: string]: string };
  collection: string;
}

export const DateField = ({
  field,
  value,
  onChange,
  errors = {},
  collection,
}: DateFieldProps) => {
  const { t } = useTranslation();

  const typedDateValue = value as unknown as Timestamp & Date;
  const dateValue = typedDateValue?.seconds
    ? typedDateValue.toDate()
    : typedDateValue;

  const handleDateChange = (date: Date | undefined) => {
    onChange(field.name, date);
  };

  const label = t(field.label) + (field.required ? "*" : "");

  return (
    <>
      <FormDatePicker
        onChange={handleDateChange}
        value={dateValue}
        collection={collection}
        label={label}
        fieldName={field.name}
        error={!!errors[field.name]}
        fieldType={field.type as "datePicker" | "dateTime" | "dateTimeNoYear"}
      />
      {errors[field.name] && (
        <HelperText type="error">{t(errors[field.name])}</HelperText>
      )}
    </>
  );
};
